import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Input, InputArea, Button } from 'wix-style-react'
import MessageBoxFunctionalLayout from 'components/shared/MessageBoxFunctionalLayout'
import generate from 'firebase-auto-ids'
import ImageIcon from 'react-icons/lib/fa/image'
import _ from 'lodash'

import { addProduct, updateProduct } from 'controllers/products'
import UploadButton from 'components/editor/assetsManager/UploadButton'
import { TEAL, LIGHT_BLUE, BLUE, LIGHT_GRAY, HELVETICA } from 'components/styles'
import { IMAGE_FILETYPES } from 'utils/uploadUtils'
import Droppable from 'components/editor/assetsManager/Droppable'
import UploadDisclimer from 'components/editor/assetsManager/UploadDisclimer'
import ProductImage from './addProduct/ProductImage'
import Text from 'components/common/Text'

const IMAGES_LIMIT = 5

const Container = styled.div`
  width: 100%;
  height: 36em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`
const BaseInfoContainer = styled.div`
  width: 100%;
  height: 16em;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 1px 2px 4px 1px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: row;
`
const ImagesContainer = styled.div`
  width: 100%;
  height: 14em;
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 1px 2px 4px 1px rgba(0, 0, 0, 0.5);
`
const ButtonContainer = styled.div`
  width: 100%;
  height: 3em;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`
const AddButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 8em;
  height: 2.8em;
  border-radius: 1.5em;
  cursor: pointer;
  user-select: none;
  background-color: ${TEAL};
  margin-left: 1.1em;

  &:hover {
    border: solid 1px ${LIGHT_BLUE};
  }
`
const ButtonDisabled = AddButton.extend`
  background-color: ${LIGHT_GRAY};
  border: solid 1px ${LIGHT_GRAY};
  cursor: default;
  &:hover {
    border: solid 1px ${LIGHT_GRAY};
  }
`
const BaseInfoLeftPart = styled.div`
  flex: 1;
  height: 90%;
  margin-left: 2em;
  margin-right: 4em;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`
const BaseInfoRightPart = styled.div`
  flex: 1;
  height: 10em;
  margin-left: 1em;
  margin-right: 2em;
`
const InputTitle = styled.div`
  margin-left: 0.5em;
  margin-top: 1em;
`
const ImagesHeader = styled.div`
  height: 2em;
  display: flex;
  margin-left: 1em;
  margin-right: 1em;
  margin-top: 1em;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
const AddImageButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 128px;
  height: 34px;
  border-radius: 17px;
  border: solid 1px #ffffff;
  cursor: pointer;
  margin-left: 1em;
  color: #fff;
  background-color: ${BLUE};
  user-select: none;

  &:hover {
    border: solid 1px ${LIGHT_BLUE};
  }
`
const ImagesBlock = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 1em;
  height: 9em;
  border: dashed 1px ${LIGHT_GRAY};
`
const ImagesBlockEpmty = ImagesBlock.extend`
  flex-direction: column;
  justify-content: center;
`
const AddImageCaption = styled.div`
  ${HELVETICA}
  color: ${TEAL};
  margin-top: 1em;
  font-weight: 500
`

const NEW = 'NEW'
const EDIT = 'EDIT'

class AddProduct extends Component {

  constructor (props) {
    super(props)
    // console.log('addProduct constructor', props.product)
    this.state = this.makeStateByProps(props.product)
  }

  makeDefaultState () {
    return {
      id: generate(_.now()),
      title: '',
      price: 0,
      productUrl: '',
      description: '',
      files: [],
      mode: NEW,
      deleteAssets: []
    }
  }

  makeStateByProps (p) {
    if (p) {
      return {
        id: p.id,
        title: p.title,
        price: p.price,
        productUrl: p.productUrl,
        description: p.description,
        files: p.assets,
        mode: EDIT,
        deleteAssets: []
      }
    } else {
      return this.makeDefaultState()
    }
  }

  onInputChange = (paramName) => {
    return (e) => {
      this.setState({
        [paramName]: e.target.value
      })
    }
  }

  renderBaseInfoBlock () {
    const { title, price, productUrl, description } = this.state
    return (
      <BaseInfoContainer>
        <BaseInfoLeftPart>
          <InputTitle><Text>*Title</Text></InputTitle>
          <Input
            value={title}
            onChange={this.onInputChange('title')}
            roundInput
            placeholder='Short sleeve t-shirt'
            autoFocus
          />

          <InputTitle><Text>*Price</Text></InputTitle>
          <Input
            value={price}
            onChange={this.onInputChange('price')}
            roundInput
            placeholder='$0.00'
          />

          <InputTitle><Text>*Destination Url</Text></InputTitle>
          <Input
            value={productUrl}
            onChange={this.onInputChange('productUrl')}
            roundInput
            placeholder='http://yourstore.com/yourproduct'
          />
        </BaseInfoLeftPart>
        <BaseInfoRightPart>
          <InputTitle><Text>*Description</Text></InputTitle>
          <InputArea
            value={description}
            onChange={this.onInputChange('description')}
            rows={5}
          />
        </BaseInfoRightPart>
      </BaseInfoContainer>
    )
  }

  onChooseFile = (file) => {
    // console.log('onChooseFile', file)
    const files = _.clone(this.state.files)
    if (files.length < IMAGES_LIMIT) {
      files.push(file)
      this.setState({
        files: files
      })
    }
  }

  onDeleteImage = (i) => {
    return () => {
      const files = _.clone(this.state.files)
      const deleteAssets = _.clone(this.state.deleteAssets)
      if (_.has(files, [i, 'url'])) {
        deleteAssets.push(files[i])
      }
      files.splice(i, 1)
      this.setState({
        files: files,
        deleteAssets: deleteAssets
      })
    }
  }

  renderFile = (file, i) => {
    let src = file.url
    if (!src) src = window.URL.createObjectURL(file)
    return (
      <ProductImage
        key={i}
        src={src}
        onDelete={this.onDeleteImage(i)}
      />
    )
  }

  renderImages = () => {
    const { files } = this.state
    if (files.length > 0) {
      return (
        <ImagesBlock>
          {_.map(files, this.renderFile)}
        </ImagesBlock>
      )
    } else {
      return (
        <ImagesBlockEpmty>
          <ImageIcon size='4em' color={LIGHT_GRAY} />
          <AddImageCaption>Drop files to upload</AddImageCaption>
        </ImagesBlockEpmty>
      )
    }

  }

  renderImagesBlock () {
    const { appId } = this.props
    return (
      <ImagesContainer>
        <ImagesHeader>
          <Text>*Images</Text>
          <UploadButton
            appId={appId}
            isImageViewer={false}
            onChooseFile={this.onChooseFile}
          >
            <AddImageButton>Upload Images</AddImageButton>
          </UploadButton>
        </ImagesHeader>
        <Droppable
          dragOverlay={<UploadDisclimer />}
          onDropAccepted={this.onChooseFile}
          onDropRejected={() => console.log('drop rejected')}
          filetypes={IMAGE_FILETYPES}
        >
          {this.renderImages()}
        </Droppable>
      </ImagesContainer>

    )
  }

  apply = () => {
    // console.log('apply')
    const {id, title, price, productUrl, description, files, mode, deleteAssets} = this.state
    const { appId, onClose } = this.props
    const info = { id, title, price, productUrl, description }
    if (mode === NEW) {
      this.props.dispatch(addProduct(appId, info, files))
      this.setState(this.makeDefaultState())
    } else {
      this.props.dispatch(updateProduct(appId, info, files, deleteAssets))
      onClose()
    }
  }


  renderOkButton = () => {
    const { title, price, productUrl, description, files, mode } = this.state
    const isEnabled = title !== '' && price !== '' && productUrl !== '' && description !== '' && files.length > 0
    let buttonTitle = 'Add Product'
    if (mode === EDIT) buttonTitle = 'Save Product'
    if (isEnabled) {
      return (
        <AddButton onClick={this.apply}>
          <Text color='white'>{buttonTitle}</Text>
        </AddButton>
      )
    } else {
      return (
        <ButtonDisabled>
          <Text color='white'>{buttonTitle}</Text>
        </ButtonDisabled>
      )
    }
  }

  renderButtonBlock () {
    return (
      <ButtonContainer>
        <Button
          onClick={this.props.onClose}
          size='small'
          theme='transparentblue'
        >
          Cancel
        </Button>
        {this.renderOkButton()}
      </ButtonContainer>
    )
  }

  render () {
    const { onClose } = this.props
    return (
      <MessageBoxFunctionalLayout
        theme='blue'
        title='Add Product'
        onCancel={onClose}
        disableConfirmation
        hideFooter
        width='60em'
        id='addProductLayout'
      >
        <Container id='addProduct'>
          {this.renderBaseInfoBlock()}
          {this.renderImagesBlock()}
          {this.renderButtonBlock()}
        </Container>
      </MessageBoxFunctionalLayout>
    )
  }
}

AddProduct.propTypes = {
  onClose: PropTypes.func.isRequired,
  appId: PropTypes.string.isRequired,
  product: PropTypes.object
}

export default connect()(AddProduct)



// WEBPACK FOOTER //
// ./src/components/shared/AddProduct.js